import { render, staticRenderFns } from "./bookerFlights.vue?vue&type=template&id=48953c05&scoped=true"
import script from "./bookerFlights.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerFlights.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerFlights.vue?vue&type=style&index=0&id=48953c05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48953c05",
  null
  
)

export default component.exports